import { render, staticRenderFns } from "./videoiframe.vue?vue&type=template&id=58e7b448&"
import script from "./videoiframe.vue?vue&type=script&lang=js&"
export * from "./videoiframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58e7b448')) {
      api.createRecord('58e7b448', component.options)
    } else {
      api.reload('58e7b448', component.options)
    }
    module.hot.accept("./videoiframe.vue?vue&type=template&id=58e7b448&", function () {
      api.rerender('58e7b448', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21y67tErl5yTr/JS/videoiframe.vue"
export default component.exports